import AppDispatcher from '../core/AppDispatcher.jsx';
import {ActionTypes} from '../constants/SelectCustomerConstants.js';
import ClientsAPI from '../apis/ClientsAPI.js';

module.exports = {
    setClientOin:(clientOin) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_CLIENT_OIN,
            clientOin: clientOin
        });
        ClientsAPI.retrieveClient(clientOin);
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/ClientResultsActions.js